<template>
    <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
            <div class="containerScroll">
                <table align="center" border="1" width="1200">
                    <tbody>
                    <tr>
                        <td align="center"><b><abbr title="Trabajo en Alturas">FPE/ESTANDAR 1</abbr></b></td>
                        <td align="center"><b><abbr title="Seguridad Vehicular">FPE/ESTANDAR 3</abbr></b></td>
                        <td align="center"><b><abbr title="Seguridad Eléctrica">FPE/ESTANDAR 4</abbr></b></td>
                        <td align="center"><b><abbr title="Ingreso a Espacios Confinados">FPE/ESTANDAR 6</abbr></b></td>
                        <td align="center"><b><abbr title="Trabajos en Caliente">FPE/ESTANDAR 7</abbr></b></td>
                        <td align="center"><b><abbr title="Excavaciones">FPE/ESTANDAR 8</abbr></b></td>
                        <td align="center"><b><abbr title="Izaje y Levantamiento de cargas">FPE ESTANDAR 9</abbr></b>
                        </td>
                        <td align="center"><b><abbr title="Trabajos Cercanos al Agua">FPE/ESTANDAR 10</abbr></b></td>
                        <td align="center"><b><abbr title="Trabajos Cerca de Ferrocarriles">FPE/ESTANDAR 11</abbr></b>
                        </td>
                        <td align="center"><b><abbr title="Taludes y Pilas">FPE/ESTANDAR 12</abbr></b></td>
                        <td align="center"><b><abbr
                                title="Exposición a superficies calientes (Calor directo sobre el trabajador)">FPE/ESTANDAR
                            13</abbr></b></td>
                    </tr>

                    <tr>
                        <td align="center" width="30"><b><font :color="this.cumple==true?'GREEN':'RED'"><b>{{this.cumple==true?'CUMPLE':'NO CUMPLE'}}</b></font></b></td>
                        <td align="center" width="30"><b><font :color="this.cumple2==true?'GREEN':'RED'"><b>{{this.cumple2==true?'CUMPLE':'NO CUMPLE'}}</b></font></b></td>
                        <td align="center" width="30"><b><font :color="this.cumple3==true?'GREEN':'RED'"><b>{{this.cumple3==true?'CUMPLE':'NO CUMPLE'}}</b></font></b></td>
                        <td align="center" width="30"><b><font :color="this.cumple4==true?'GREEN':'RED'"><b>{{this.cumple4==true?'CUMPLE':'NO CUMPLE'}}</b></font></b></td>
                        <td align="center" width="30"><b><font :color="this.cumple5==true?'GREEN':'RED'"><b>{{this.cumple5==true?'CUMPLE':'NO CUMPLE'}}</b></font></b></td>
                        <td align="center" width="30"><b><font :color="this.cumple6==true?'GREEN':'RED'"><b>{{this.cumple6==true?'CUMPLE':'NO CUMPLE'}}</b></font></b></td>
                        <td align="center" width="30"><b><font :color="this.cumple7==true?'GREEN':'RED'"><b>{{this.cumple7==true?'CUMPLE':'NO CUMPLE'}}</b></font></b></td>
                        <td align="center" width="30"><b><font :color="this.cumple8==true?'GREEN':'RED'"><b>{{this.cumple8==true?'CUMPLE':'NO CUMPLE'}}</b></font></b></td>
                        <td align="center" width="30"><b><font :color="this.cumple9==true?'GREEN':'RED'"><b>{{this.cumple9==true?'CUMPLE':'NO CUMPLE'}}</b></font></b></td>
                        <td align="center" width="30"><b><font :color="this.cumple10==true?'GREEN':'RED'"><b>{{this.cumple10==true?'CUMPLE':'NO CUMPLE'}}</b></font></b></td>
                        <td align="center" width="30"><b><font :color="this.cumple11==true?'GREEN':'RED'"><b>{{this.cumple11==true?'CUMPLE':'NO CUMPLE'}}</b></font></b></td>
                    </tr>

                    <tr>
                        <td valign="top" style="min-width: 300px"><font color="NAVY" size="-4"><font color="RED" size="-3"> <span
                                v-html="this.html"></span></font></font></td>
                        <td valign="top" style="min-width: 300px"><font color="NAVY" size="-4"><font color="RED" size="-3"> <span
                                v-html="this.html2"></span></font></font></td>
                        <td valign="top" style="min-width: 300px"><font color="NAVY" size="-3"><font color="RED" size="-3"> <span
                                v-html="this.html3"></span></font></font></td>
                        <td valign="top" style="min-width: 300px"><font color="NAVY" size="-3"><font color="RED" size="-3"> <span
                                v-html="this.html4"></span></font></font></td>
                        <td valign="top" style="min-width: 300px"><font color="NAVY" size="-3"><font color="RED" size="-3"> <span
                                v-html="this.html5"></span></font></font></td>
                        <td valign="top" style="min-width: 300px"><font color="NAVY" size="-3"><font color="RED" size="-3"> <span
                                v-html="this.html6"></span></font></font></td>
                        <td valign="top" style="min-width: 300px"><font color="NAVY" size="-3"><font color="RED" size="-3"> <span
                                v-html="this.html7"></span></font></font></td>
                        <td valign="top" style="min-width: 300px"><font color="NAVY" size="-3"><font color="RED" size="-3"> <span
                                v-html="this.html8"></span></font></font></td>
                        <td valign="top" style="min-width: 300px"><font color="NAVY" size="-3"><font color="RED" size="-3"> <span
                                v-html="this.html9"></span></font></font></td>
                        <td valign="top" style="min-width: 300px"><font color="NAVY" size="-3"><font color="RED" size="-3"> <span
                                v-html="this.html10"></span></font></font></td>
                        <td valign="top" style="min-width: 300px"><font color="NAVY" size="-3"><font color="RED" size="-3"> <span
                                v-html="this.html11"></span></font></font></td>

                    </tr>

                    <form action="fpe3.php" method="POST" wfd-id="4"></form>
                    <tr>
                        <td colspan="4">
                            <v-select
                                    :items="['POSITIVO','NEGATIVO']"
                                    v-model="fpeObject.dopping"
                                    label="DOPPING"
                                    required
                            ></v-select>
                        </td>
                        <td colspan="4">
                            <v-select
                                    :items="['POSITIVO','NEGATIVO']"
                                    v-model="fpeObject.alcoholCheck"
                                    label="ALCOHOL CHECK"
                                    required
                            ></v-select>
                        </td>
                        <td colspan="3">
                            <v-select
                                    :items="['NORMAL','ANORMAL']"
                                    v-model="fpeObject.t3t4tsh"
                                    label="T3-T4-TSH"
                                    required
                            ></v-select>
                        </td>
                    </tr>
                    <input type="hidden" value="3278" name="registro" wfd-id="19">

                    <tr>
                        <td colspan="11" align="center">
                            <v-btn color="primary" @click="save" dark>Actualizar</v-btn>
                        </td>
                    </tr>

                    <form action="fpe2.php" method="POST" wfd-id="0"></form>
                    <tr>


                        <td>
                            <v-checkbox v-model="fpeObject.fpe1" label="Apto"></v-checkbox>
                        </td>
                        <td>
                            <v-checkbox v-model="fpeObject.fpe3" label="Apto"></v-checkbox>
                        </td>
                        <td>
                            <v-checkbox v-model="fpeObject.fpe4" label="Apto"></v-checkbox>
                        </td>
                        <td>
                            <v-checkbox v-model="fpeObject.fpe6" label="Apto"></v-checkbox>
                        </td>
                        <td>
                            <v-checkbox v-model="fpeObject.fpe7" label="Apto"></v-checkbox>
                        </td>
                        <td>
                            <v-checkbox v-model="fpeObject.fpe8" label="Apto"></v-checkbox>
                        </td>
                        <td>
                            <v-checkbox v-model="fpeObject.fpe9" label="Apto"></v-checkbox>
                        </td>
                        <td>
                            <v-checkbox v-model="fpeObject.fpe10" label="Apto"></v-checkbox>
                        </td>
                        <td>
                            <v-checkbox v-model="fpeObject.fpe11" label="Apto"></v-checkbox>
                        </td>
                        <td>
                            <v-checkbox v-model="fpeObject.fpe12" label="Apto"></v-checkbox>
                        </td>
                        <td>
                            <v-checkbox v-model="fpeObject.fpe13" label="Apto"></v-checkbox>
                        </td>

                    </tr>
                    <input type="hidden" value="3278" name="registro" wfd-id="6">
                    <tr>
                        <td colspan="11" align="center">
                            <div class="text-xs-center">
                                <v-btn color="primary" @click="save" dark>Guardar</v-btn>
                                <v-btn color="primary" @click="print()" dark>Generar certificados</v-btn>
                            </div>
                        </td>
                    </tr>


                    </tbody>
                </table>

                <br>
                <br>
                <table align="center" width="650" border="1">
                    <tbody>
                    <tr>
                        <td></td>
                        <td align="center"><b><abbr title="Trabajo en Alturas">FPE/ESTANDAR 1</abbr></b></td>
                        <td align="center"><b><abbr title="Seguridad Vehicular">FPE/ESTANDAR 3</abbr></b></td>
                        <td align="center"><b><abbr title="Seguridad Eléctrica">FPE/ESTANDAR 4</abbr></b></td>
                        <td align="center"><b><abbr title="Ingreso a Espacios Confinados">FPE/ESTANDAR 6</abbr></b></td>
                        <td align="center"><b><abbr title="Trabajos en Caliente">FPE/ESTANDAR 7</abbr></b></td>
                        <td align="center"><b><abbr title="Excavaciones">FPE/ESTANDAR 8</abbr></b></td>
                        <td align="center"><b><abbr title="Izaje y Levantamiento de cargas">FPE/ESTANDAR 9</abbr></b>
                        </td>
                        <td align="center"><b><abbr title="Trabajos Cercanos al Agua">FPE/ESTANDAR 10</abbr></b></td>
                        <td align="center"><b><abbr title="Trabajos Cerca de Ferrocarriles">FPE/ESTANDAR 11</abbr></b>
                        </td>
                        <td align="center"><b><abbr title="Taludes y Pilas">FPE/ESTANDAR 12</abbr></b></td>
                        <td align="center"><b><abbr
                                title="Exposición a superficies calientes (Calor directo sobre el trabajador)">FPE/ESTANDAR
                            13</abbr></b></td>
                    </tr>

                    <tr>
                        <td><b>EKG</b></td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                    </tr>

                    <tr>
                        <td><b>PRESION ARTERIAL</b></td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                    </tr>


                    <tr>
                        <td><b>ENE/EEG</b></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                    </tr>

                    <tr>
                        <td><b>TEST EQUILIBRIO</b></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                    </tr>

                    <tr>
                        <td><b>HISTORIA CLINICA/EXÁMEN FÍSICO</b></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                    </tr>

                    <tr>
                        <td><b>COLESTEROL</b></td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                    </tr>

                    <tr>
                        <td><b>TRIGLICERIDOS</b></td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                    </tr>

                    <tr>
                        <td><b>FOBIAS</b></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                    </tr>

                    <tr>
                        <td><b>GLICEMIA</b></td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                    </tr>

                    <tr>
                        <td><b>DOPPING</b></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                    </tr>

                    <tr>
                        <td><b>ALCOHOL CHECK</b></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                    </tr>

                    <tr>
                        <td><b>AUDIOMETRIA</b></td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                    </tr>

                    <tr>
                        <td><b>OFTALMOLOGIA</b></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                    </tr>

                    <tr>
                        <td><b>DALTONISMO</b></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                    </tr>

                    <tr>
                        <td><b>RX COLUMNA</b></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                    </tr>

                    <tr>
                        <td><b>ESPIROMETRIA</b></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                    </tr>

                    <tr>
                        <td><b>RX TORAX</b></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                    </tr>

                    <tr>
                        <td><b>T3-T4-TSH</b></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                    </tr>

                    <tr>
                        <td><b>PLIEGUES CUTANEOS</b></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center">X</td>
                    </tr>


                    </tbody>
                </table>
            </div>
        </v-form>
        <v-dialog
                v-model="dialogSuccess"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Se guardó con exito la información</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogSuccess = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>
<script>

    import Anexo from "../../../model/Anexo";

    export default {
        props: ['company'],
        data() {
            return {
                radioGroup: 1,
                search: '',
                dialogSuccess: '',
                valid: false,
                colorHeader1: "RED",
                colorHeader2: "RED",
                colorHeader3: "RED",
                colorHeader4: "RED",
                colorHeader5: "RED",
                colorHeader6: "RED",
                colorHeader7: "RED",
                colorHeader8: "RED",
                colorHeader9: "RED",
                colorHeader10: "RED",
                colorHeader11: "RED",
                eeg: "",
                eegDiagnostic: "",
                ekg: "",
                ekgDiagnostic: "",
                pruebasEquilibrio: "",
                pruebasEquilibrioDiagnostic: "",
                historialClinico: "",
                historialClinicoDiagnostic: "",
                cuestionarioFobias: "",
                cuestionarioFobiasDiagnostic: "",
                rxColumna: "",
                rxColumnaDiagnostic: "",
                rxTorax: "",
                rxToraxDiagnostic: "",
                pliegues: "",
                plieguesDiagnostic: "",
                espirometria: "",
                espirometriaDiagnostic: "",
                colesterol: "",
                trigliceridos: "",

                listAnamnesis: "",
                audios: "",
                html: "",
                html2: "",
                html3: "",
                html4: "",
                html5: "",
                html6: "",
                html7: "",
                html8: "",
                html9: "",
                html10: "",
                html11: "",
                html12: "",
                html13: "",

                cumple: false,
                cumple2: false,
                cumple3: false,
                cumple4: false,
                cumple5: false,
                cumple6: false,
                cumple7: false,
                cumple8: false,
                cumple9: false,
                cumple10: false,
                cumple11: false,
                cumple12: false,
                cumple13: false,


                requiredField: [v => !!v || 'Es requerido'],
                fpeObject: "",
                doctor:""

            };
        },
        methods: {
            cleanData() {

            },
            getFormattedDate(dateReg) {
                var ua = navigator.userAgent.toLowerCase();
                var date;
                if (ua.indexOf('safari') != -1) {
                    if (ua.indexOf('chrome') > -1) {
                        // Para chrome
                        date = new Date(dateReg);
                    } else {
                        // Para Safari
                        if (!(dateReg instanceof Date)) {
                            var b = dateReg.toString().split(/\D/);
                            date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
                        } else {
                            date = new Date(dateReg);
                        }
                    }
                } else {
                    // Otros navegadores
                    date = new Date(dateReg);
                }
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var min = date.getMinutes();
                var sec = date.getSeconds();
                month = (month < 10 ? "0" : "") + month;
                day = (day < 10 ? "0" : "") + day;
                hour = (hour < 10 ? "0" : "") + hour;
                min = (min < 10 ? "0" : "") + min;
                sec = (sec < 10 ? "0" : "") + sec;
                var str = date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
                return str;
            },

            valueColum1() {
                //ENE/EEG
                //this.$store.state.fileData=[]
                let htmlRed = ""
                let htmlBlue = ""
                let today = new Date();
                let yyyy = today.getFullYear();
                for (let i = 0; i < this.$store.state.patientFileList.length; i++) {
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ELECTROENCEFALOGRAMA") || this.$store.state.patientFileList[i].group.includes("ELECTROENCEFALOGRAMA"))) {
                        this.eeg = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.eegDiagnostic = diagnosticsAnexos
                    }
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ELECTROCARDIOGRAMA") || this.$store.state.patientFileList[i].group.includes("ECO-CARDIOGRAMA"))) {
                        this.ekg = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.ekgDiagnostic = diagnosticsAnexos
                    }
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("PRUEBAS DE EQUILIBRIO"))) {
                        this.pruebasEquilibrio = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.pruebasEquilibrioDiagnostic = diagnosticsAnexos
                    }
                    if (this.listAnamnesis[0] != null) {
                        let diagnosticsAnexos= "<br>"
                        if(this.listAnamnesis[0].diagnosticos != null){
                            this.historialClinico = true
                            for(let j=0; j<this.listAnamnesis[0].diagnosticos.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.listAnamnesis[0].diagnosticos[j].name + "<br>"
                            }
                        }
                        this.historialClinicoDiagnostic = diagnosticsAnexos
                    }
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("CUESTIONARIO DE FOBIAS"))) {
                        this.cuestionarioFobias = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.cuestionarioFobiasDiagnostic = diagnosticsAnexos
                    }


                }
                if (!this.eeg) {
                    htmlRed += '<br>-ENE/EEG'
                } else {
                    htmlBlue += '<br><strong><u>-ENE/EEG</u>: </strong>' + this.eegDiagnostic
                }
                //EKG
                if (!this.ekg) {
                    htmlRed += '<br>-EKG'
                } else {
                    htmlBlue += '<br><strong><u>-EKG</u>: </strong>' + this.ekgDiagnostic
                }
                //PA
                if (!this.pruebasEquilibrio) {
                    htmlRed += '<br>-TEST EQUILIBRIO'
                } else {
                    htmlBlue += '<br><strong><u>-TEST EQUILIBRIO</u>: </strong>' + this.pruebasEquilibrioDiagnostic
                }

                //HISTORIA CLINICA
                if (!this.historialClinico) {
                    htmlRed += '<br>-HISTORIA CLINICA/EXAMEN FÍSICO'
                } else {
                    htmlBlue += '<br><strong><u>-HISTORIA CLINICA/EXAMEN FÍSICO</u>: </strong>' + this.historialClinicoDiagnostic
                }

                //COLESTEROL HDL
                try {
                    //COLESTEROL HDL
                    if ((this.listAnamnesis[0] != null && (this.listAnamnesis[0].signosVitales[14].valor == null) || this.listAnamnesis[0].signosVitales[14].valor == "")) {
                        htmlRed += '<br>-COLESTEROL HDL'
                    } else {
                        htmlBlue += '<br><strong><u>-COLESTEROL HDL</u>: </strong>' + this.listAnamnesis[0].signosVitales[14].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-COLESTEROL HDL'

                }


                try {
                    //TRIGLICERIDOS
                    if ((this.listAnamnesis[0] != null && (this.listAnamnesis[0].signosVitales[11].valor == null) || this.listAnamnesis[0].signosVitales[11].valor == "")) {
                        htmlRed += '<br>-TRIGLICERIDOS'
                    } else {
                        htmlBlue += '<br><strong><u>-TRIGLICERIDOS</u>: </strong>' + this.listAnamnesis[0].signosVitales[11].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-TRIGLICERIDOS'
                }

                try {
                    //GLICEMIA
                    if ((this.listAnamnesis[0] != null && (this.listAnamnesis[0].signosVitales[13].valor == null) || this.listAnamnesis[0].signosVitales[13].valor == "")) {
                        htmlRed += '<br>-GLICEMIA'
                    } else {
                        htmlBlue += '<br><strong><u>-GLICEMIA</u>: </strong>' + this.listAnamnesis[0].signosVitales[13].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-TRIGLICERIDOS'
                }

                try {
                    //PRESION ARTERIA
                    if ((this.listAnamnesis[0] != null && (this.listAnamnesis[0].signosVitales[1].valor == null) || this.listAnamnesis[0].signosVitales[1].valor == "")) {
                        htmlRed += '<br>-P.A.'
                    } else {
                        htmlBlue += '<br><strong><u>-P.A.</u>: </strong>' + this.listAnamnesis[0].signosVitales[1].valor + "/" + this.listAnamnesis[0].signosVitales[2].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-TRIGLICERIDOS'
                }

                //FOBIAS

                if (!this.cuestionarioFobias) {
                    htmlRed += '<br>-FOBIAS'
                } else {
                    htmlBlue += '<br><strong><u>-FOBIAS</u>: </strong>' + this.cuestionarioFobiasDiagnostic
                }
                //DOPPING
                if (this.fpeObject.dopping == "") {
                    htmlRed += '<br>-DOPING'
                } else if (this.fpeObject.dopping == 'POSITIVO') {
                    htmlBlue += '<br><strong><u>-DOPING</u>: </strong>POSITIVO'
                } else if (this.fpeObject.dopping == 'NEGATIVO') {
                    htmlBlue += '<br><strong><u>-DOPING</u>: </strong>NEGATIVO'
                }
                //ALCOHOL CHECK
                if (this.fpeObject.alcoholCheck == "") {
                    htmlRed += '<br>-ALCOHOL CHECK'
                } else if (this.fpeObject.alcoholCheck == 'POSITIVO') {
                    htmlBlue += '<br><strong><u>-ALCOHOL CHECK</u>: </strong>POSITIVO'
                } else if (this.fpeObject.alcoholCheck == 'NEGATIVO') {
                    htmlBlue += '<br><strong><u>-ALCOHOL CHECK</u>: </strong>NEGATIVO'
                }
                if (htmlRed == "") {
                    this.cumple = true
                }

                htmlRed = '<span  style="color: RED;">' + htmlRed + '</span>'
                htmlBlue = '<span style="color: BLUE;">' + htmlBlue + '</span>'
                this.html = htmlRed + htmlBlue

            },

            valueColum2() {
                let htmlRed = ""
                let htmlBlue = ""
                let today = new Date();
                let yyyy = today.getFullYear();
                for (let i = 0; i < this.$store.state.patientFileList.length; i++) {
                    if (this.$store.state.patientFileList[i] != null && this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ELECTROENCEFALOGRAMA") || this.$store.state.patientFileList[i].group.includes("ELECTROENCEFALOGRAMA"))) {
                        this.eeg = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.eegDiagnostic = diagnosticsAnexos
                        //+" "+this.$store.state.patientFileList[i].diagnosticos==='undefined'?"":this.$store.state.patientFileList[i].diagnosticos
                    }
                    if (this.$store.state.patientFileList[i] != null && this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ELECTROCARDIOGRAMA") || this.$store.state.patientFileList[i].group.includes("ECO-CARDIOGRAMA"))) {
                        this.ekg = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.ekgDiagnostic = diagnosticsAnexos
                    }
                    if (this.$store.state.patientFileList[i] != null && this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("PRUEBAS DE EQUILIBRIO"))) {
                        this.pruebasEquilibrio = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.pruebasEquilibrioDiagnostic = diagnosticsAnexos
                    }
                    if (this.$store.state.patientFileList[i] != null && this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ANAMNESIS Y EXAMEN FÍSICO"))) {
                        this.historialClinico = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.historialClinicoDiagnostic = diagnosticsAnexos
                    }
                    if (this.$store.state.patientFileList[i] != null && this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("CUESTIONARIO DE FOBIAS"))) {
                        this.cuestionarioFobias = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.cuestionarioFobiasDiagnostic = diagnosticsAnexos
                    }
                    if (this.$store.state.patientFileList[i] != null && this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("COLUMNA"))) {
                        this.rxColumna = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.rxColumnaDiagnostic = diagnosticsAnexos
                    }
                }
                if (!this.eeg) {
                    htmlRed += '<br>-ENE/EEG'
                } else {
                    htmlBlue += '<br><strong><u>-ENE/EEG</u>: </strong>' + this.eegDiagnostic
                }
                //EKG
                if (!this.ekg) {
                    htmlRed += '<br>-EKG'
                } else {
                    htmlBlue += '<br><strong><u>-EKG</u>: </strong>' + this.ekgDiagnostic
                }


                //HISTORIA CLINICA
                if (!this.historialClinico) {
                    htmlRed += '<br>-HISTORIA CLINICA/EXAMEN FÍSICO'
                } else {
                    htmlBlue += '<br><strong><u>-HISTORIA CLINICA/EXAMEN FÍSICO</u>: </strong>' + this.historialClinicoDiagnostic
                }

                //COLESTEROL HDL
                try {
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[14].valor == null) || this.listAnamnesis[0].signosVitales[14].valor == "")) {
                        htmlRed += '<br>-COLESTEROL HDL'
                    } else {
                        htmlBlue += '<br><strong><u>-COLESTEROL HDL</u>: </strong>' + this.listAnamnesis[0].signosVitales[14].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-COLESTEROL HDL'

                }

                try {
                    //TRIGLICERIDOS
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[11].valor == null) || this.listAnamnesis[0].signosVitales[11].valor == "")) {
                        htmlRed += '<br>-TRIGLICERIDOS'
                    } else {
                        htmlBlue += '<br><strong><u>-TRIGLICERIDOS</u>: </strong>' + this.listAnamnesis[0].signosVitales[11].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-TRIGLICERIDOS'

                }

                try {
                    //GLICEMIA
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[13].valor == null) || this.listAnamnesis[0].signosVitales[13].valor == "")) {
                        htmlRed += '<br>-GLICEMIA'
                    } else {
                        htmlBlue += '<br><strong><u>-GLICEMIA</u>: </strong>' + this.listAnamnesis[0].signosVitales[13].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-GLICEMIA'
                }


                try {
                    //PRESION ARTERIA
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[1].valor == null) || this.listAnamnesis[0].signosVitales[1].valor == "")) {
                        htmlRed += '<br>-P.A.'
                    } else {
                        htmlBlue += '<br><strong><u>-P.A.</u>: </strong>' + this.listAnamnesis[0].signosVitales[1].valor + "/" + this.listAnamnesis[0].signosVitales[2].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-P.A.'
                }


                //FOBIAS
                if (!this.rxColumna) {
                    htmlRed += '<br>-RX COLUMNA'
                } else {
                    htmlBlue += '<br><strong><u>-RX COLUMNA</u>: </strong>' + this.rxColumnaDiagnostic
                }

                //AUDIOMETRIA
                try {
                    if (this.audios[0] == null || ((this.audios[0].value.diagnosticos[0].name == null) || this.audios[0].value.diagnosticos[0].name == "")) {
                        htmlRed += '<br>-AUDIOMETRIA'
                    } else {
                        htmlBlue += '<br><strong><u>-AUDIOMETRIA</u>: </strong>' + this.audios[0].value.diagnosticos[0].name
                    }
                } catch (e) {
                    htmlRed += '<br>-AUDIOMETRIA'
                }


                if (htmlRed == "") {
                    this.cumple2 = true
                }

                htmlRed = '<font color="RED">' + htmlRed + '</font>'
                htmlBlue = '<font color="BLUE">' + htmlBlue + '</font>'
                this.html2 = htmlRed + htmlBlue


            },
            valueColum3() {
                let htmlRed = ""
                let htmlBlue = ""
                let today = new Date();
                let yyyy = today.getFullYear();
                for (let i = 0; i < this.$store.state.patientFileList.length; i++) {
                    if (this.$store.state.patientFileList[i] != null && this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ELECTROENCEFALOGRAMA") || this.$store.state.patientFileList[i].group.includes("ELECTROENCEFALOGRAMA"))) {
                        this.eeg = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.eegDiagnostic = diagnosticsAnexos
                        //+" "+this.$store.state.patientFileList[i].diagnosticos==='undefined'?"":this.$store.state.patientFileList[i].diagnosticos
                    }
                    if (this.$store.state.patientFileList[i] != null && this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ELECTROCARDIOGRAMA") || this.$store.state.patientFileList[i].group.includes("ECO-CARDIOGRAMA"))) {
                        this.ekg = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.ekgDiagnostic = diagnosticsAnexos
                    }
                    if (this.$store.state.patientFileList[i] != null && this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("PRUEBAS DE EQUILIBRIO"))) {
                        this.pruebasEquilibrio = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.pruebasEquilibrioDiagnostic = diagnosticsAnexos
                    }
                    if (this.$store.state.patientFileList[i] != null && this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ANAMNESIS Y EXAMEN FÍSICO"))) {
                        this.historialClinico = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.historialClinicoDiagnostic = diagnosticsAnexos
                    }
                    if (this.$store.state.patientFileList[i] != null && this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("CUESTIONARIO DE FOBIAS"))) {
                        this.cuestionarioFobias = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.cuestionarioFobiasDiagnostic = diagnosticsAnexos
                    }
                    if (this.$store.state.patientFileList[i] != null && this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("COLUMNA"))) {
                        this.rxColumna = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.rxColumnaDiagnostic = diagnosticsAnexos
                    }
                }

                //EKG
                if (!this.ekg) {
                    htmlRed += '<br>-EKG'
                } else {
                    htmlBlue += '<br><strong><u>-EKG</u>: </strong>' + this.ekgDiagnostic
                }


                try {
                    //PRESION ARTERIA
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[1].valor == null) || this.listAnamnesis[0].signosVitales[1].valor == "")) {
                        htmlRed += '<br>-P.A.'
                    } else {
                        htmlBlue += '<br><strong><u>-P.A.</u>: </strong>' + this.listAnamnesis[0].signosVitales[1].valor + "/" + this.listAnamnesis[0].signosVitales[2].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-P.A.'
                }


                //AUDIO
                try {
                    if (this.audios[0] == null || ((this.audios[0].value.diagnosticos[0].name == null) || this.audios[0].value.diagnosticos[0].name == "")) {
                        htmlRed += '<br>-AUDIOMETRIA'
                    } else {
                        htmlBlue += '<br><strong><u>-AUDIOMETRIA</u>: </strong>' + this.audios[0].value.diagnosticos[0].name
                    }
                } catch (e) {
                    htmlRed += '<br>-AUDIOMETRIA'
                }
                if (htmlRed == "") {
                    this.cumple2 = true
                }


                try {
                    //OFTALMOLOGIA
                    if (this.$store.state.oftalmoList == null || this.$store.state.oftalmoList.length == 0 || this.$store.state.oftalmoList[0].diagnosticoRefractivo1 == "") {
                        htmlRed += '<br>-OFTALMOLOGIA'
                    } else {
                        htmlBlue += '<br><strong><u>-OFTALMOLOGIA</u>: </strong>' + this.$store.state.oftalmoList[0].diagnosticoRefractivo1
                    }
                } catch (e) {
                    htmlRed += '<br>-OFTALMOLOGIA'
                }


                try {
                    //OFTALMOLOGIA
                    if (this.$store.state.oftalmoList == null || this.$store.state.oftalmoList.length == 0 || this.$store.state.oftalmoList[0].diagnosticoRefractivo2 == "") {
                        htmlRed += '<br>-OFTALMOLOGIA'
                    } else {
                        htmlBlue += '<br><strong><u>-OFTALMOLOGIA</u>: </strong>' + this.$store.state.oftalmoList[0].diagnosticoRefractivo2
                    }
                } catch (e) {
                    htmlRed += '<br>-OFTALMOLOGIA'
                }


                try {
                    //DALTONISMO
                    if (this.$store.state.oftalmoList == null || this.$store.state.oftalmoList.length == 0 || this.$store.state.oftalmoList[0].diagnosticoPatologico == "") {
                        htmlRed += '<br>-DALTONISMO'
                    } else if (this.$store.state.oftalmoList[0].diagnosticoPatologico != "DALTONISMO") {
                        htmlBlue += '<br><strong><u>-DALTONISMO</u>: </strong>' + "SI"
                    }
                } catch (e) {
                    htmlRed += '<br>-DALTONISMO'

                }

                if (htmlRed == "") {
                    this.cumple3 = true
                }
                htmlRed = '<font color="RED">' + htmlRed + '</font>'
                htmlBlue = '<font color="BLUE">' + htmlBlue + '</font>'
                this.html3 = htmlRed + htmlBlue


            },
            valueColum4() {
                //ENE/EEG
                //this.$store.state.fileData=[]
                let htmlRed = ""
                let htmlBlue = ""
                let today = new Date();
                let yyyy = today.getFullYear();
                for (let i = 0; i < this.$store.state.patientFileList.length; i++) {
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ELECTROENCEFALOGRAMA") || this.$store.state.patientFileList[i].group.includes("ELECTROENCEFALOGRAMA"))) {
                        this.eeg = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.eegDiagnostic = diagnosticsAnexos
                        //+" "+this.$store.state.patientFileList[i].diagnosticos==='undefined'?"":this.$store.state.patientFileList[i].diagnosticos
                    }
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ELECTROCARDIOGRAMA") || this.$store.state.patientFileList[i].group.includes("ECO-CARDIOGRAMA"))) {
                        this.ekg = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.ekgDiagnostic = diagnosticsAnexos
                    }
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("PRUEBAS DE EQUILIBRIO"))) {
                        this.pruebasEquilibrio = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.pruebasEquilibrioDiagnostic = diagnosticsAnexos
                    }
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ANAMNESIS Y EXAMEN FÍSICO"))) {
                        this.historialClinico = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.historialClinicoDiagnostic = diagnosticsAnexos
                    }
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("CUESTIONARIO DE FOBIAS"))) {
                        this.cuestionarioFobias = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.cuestionarioFobiasDiagnostic = diagnosticsAnexos
                    }
                }
                if (!this.eeg) {
                    htmlRed += '<br>-ENE/EEG'
                } else {
                    htmlBlue += '<br><strong><u>-ENE/EEG</u>: </strong>' + this.eegDiagnostic
                }
                //EKG
                if (!this.ekg) {
                    htmlRed += '<br>-EKG'
                } else {
                    htmlBlue += '<br><strong><u>-EKG</u>: </strong>' + this.ekgDiagnostic
                }
                //PA
                if (!this.pruebasEquilibrio) {
                    htmlRed += '<br>-TEST EQUILIBRIO'
                } else {
                    htmlBlue += '<br><strong><u>-TEST EQUILIBRIO</u>: </strong>' + this.pruebasEquilibrioDiagnostic
                }

                //HISTORIA CLINICA
                if (!this.historialClinico) {
                    htmlRed += '<br>-HISTORIA CLINICA/EXAMEN FÍSICO'
                } else {
                    htmlBlue += '<br><strong><u>-HISTORIA CLINICA/EXAMEN FÍSICO</u>: </strong>' + this.historialClinicoDiagnostic
                }

                try {
                    //COLESTEROL HDL
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[14].valor == null) || this.listAnamnesis[0].signosVitales[14].valor == "")) {
                        htmlRed += '<br>-COLESTEROL HDL'
                    } else {
                        htmlBlue += '<br><strong><u>-COLESTEROL HDL</u>: </strong>' + this.listAnamnesis[0].signosVitales[14].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-COLESTEROL HDL'
                }


                try {
                    //TRIGLICERIDOS
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[11].valor == null) || this.listAnamnesis[0].signosVitales[11].valor == "")) {
                        htmlRed += '<br>-TRIGLICERIDOS'
                    } else {
                        htmlBlue += '<br><strong><u>-TRIGLICERIDOS</u>: </strong>' + this.listAnamnesis[0].signosVitales[11].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-TRIGLICERIDOS'
                }

                try {
                    //GLICEMIA
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[13].valor == null) || this.listAnamnesis[0].signosVitales[13].valor == "")) {
                        htmlRed += '<br>-GLICEMIA'
                    } else {
                        htmlBlue += '<br><strong><u>-GLICEMIA</u>: </strong>' + this.listAnamnesis[0].signosVitales[13].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-GLICEMIA'
                }

                try {
                    //PRESION ARTERIA
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[1].valor == null) || this.listAnamnesis[0].signosVitales[1].valor == "")) {
                        htmlRed += '<br>-P.A.'
                    } else {
                        htmlBlue += '<br><strong><u>-P.A.</u>: </strong>' + this.listAnamnesis[0].signosVitales[1].valor + "/" + this.listAnamnesis[0].signosVitales[2].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-P.A.'
                }

                //FOBIAS
                if (!this.cuestionarioFobias) {
                    htmlRed += '<br>-CUESTIONARIO DE FOBIAS'
                } else {
                    htmlBlue += '<br><strong><u>-CUESTIONARIO DE FOBIAS</u>: </strong>' + this.cuestionarioFobiasDiagnostic
                }
                //DOPPING
                if (this.fpeObject.dopping == "") {
                    htmlRed += '<br>-DOPING'
                } else if (this.fpeObject.dopping == 'POSITIVO') {
                    htmlBlue += '<br><strong><u>-DOPING</u>: </strong>POSITIVO'
                } else if (this.fpeObject.dopping == 'NEGATIVO') {
                    htmlBlue += '<br><strong><u>-DOPING</u>: </strong>NEGATIVO'
                }
                //ALCOHOL CHECK
                if (this.fpeObject.alcoholCheck == "") {
                    htmlRed += '<br>-ALCOHOL CHECK'
                } else if (this.fpeObject.alcoholCheck == 'POSITIVO') {
                    htmlBlue += '<br><strong><u>-ALCOHOL CHECK</u>: </strong>POSITIVO'
                } else if (this.fpeObject.alcoholCheck == 'NEGATIVO') {
                    htmlBlue += '<br><strong><u>-ALCOHOL CHECK</u>: </strong>NEGATIVO'
                }
                if (htmlRed == "") {
                    this.cumple4 = true
                }
                htmlRed = '<font color="RED">' + htmlRed + '</font>'
                htmlBlue = '<font color="BLUE">' + htmlBlue + '</font>'
                this.html4 = htmlRed + htmlBlue


            },

            valueColum5() {
                //ENE/EEG
                //this.$store.state.fileData=[]
                let htmlRed = ""
                let htmlBlue = ""
                let today = new Date();
                let yyyy = today.getFullYear();
                for (let i = 0; i < this.$store.state.patientFileList.length; i++) {
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ESPIROMETRIA"))) {
                        this.espirometria = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.espirometriaDiagnostic = diagnosticsAnexos
                        //+" "+this.$store.state.patientFileList[i].diagnosticos==='undefined'?"":this.$store.state.patientFileList[i].diagnosticos
                    }
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("TORAX"))) {
                        this.rxTorax = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.rxToraxDiagnostic = diagnosticsAnexos
                    }

                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ELECTROCARDIOGRAMA") || this.$store.state.patientFileList[i].group.includes("ECO-CARDIOGRAMA"))) {
                        this.ekg = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.ekgDiagnostic = diagnosticsAnexos
                    }
                }
                if (!this.espirometria) {
                    htmlRed += '<br>-ESPIROMETRIA'
                } else {
                    htmlBlue += '<br><strong><u>-ESPIROMETRIA</u>: </strong>' + this.espirometriaDiagnostic
                }
                if (!this.rxTorax) {
                    htmlRed += '<br>-RX TORAX'
                } else {
                    htmlBlue += '<br><strong><u>-RX TORAX</u>: </strong>' + this.rxToraxDiagnostic
                }
                //EKG
                if (!this.ekg) {
                    htmlRed += '<br>-EKG'
                } else {
                    htmlBlue += '<br><strong><u>-EKG</u>: </strong>' + this.ekgDiagnostic
                }

                try {
                    //GLICEMIA
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[13].valor == null) || this.listAnamnesis[0].signosVitales[13].valor == "")) {
                        htmlRed += '<br>-GLICEMIA'
                    } else {
                        htmlBlue += '<br><strong><u>-GLICEMIA</u>: </strong>' + this.listAnamnesis[0].signosVitales[13].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-GLICEMIA'
                }

                try {
                    //PRESION ARTERIA
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[1].valor == null) || this.listAnamnesis[0].signosVitales[1].valor == "")) {
                        htmlRed += '<br>-P.A.'
                    } else {
                        htmlBlue += '<br><strong><u>-P.A.</u>: </strong>' + this.listAnamnesis[0].signosVitales[1].valor + "/" + this.listAnamnesis[0].signosVitales[2].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-P.A.'
                }

                //FOBIAS
                if (htmlRed == "") {
                    this.cumple5 = true
                }


                htmlRed = '<font color="RED">' + htmlRed + '</font>'
                htmlBlue = '<font color="BLUE">' + htmlBlue + '</font>'
                this.html5 = htmlRed + htmlBlue

            },
            valueColum6() {
                //ENE/EEG
                //this.$store.state.fileData=[]
                let htmlRed = ""
                let htmlBlue = ""
                let today = new Date();
                let yyyy = today.getFullYear();
                for (let i = 0; i < this.$store.state.patientFileList.length; i++) {
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ELECTROENCEFALOGRAMA") || this.$store.state.patientFileList[i].group.includes("ELECTROENCEFALOGRAMA"))) {
                        this.eeg = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.eegDiagnostic = diagnosticsAnexos
                    }
                }
                if (!this.eeg) {
                    htmlRed += '<br>-ENE/EEG'
                } else {
                    htmlBlue += '<br><strong><u>-ENE/EEG</u>: </strong>' + this.eegDiagnostic
                }

                //PA
                if (!this.pruebasEquilibrio) {
                    htmlRed += '<br>-TEST EQUILIBRIO'
                } else {
                    htmlBlue += '<br><strong><u>-TEST EQUILIBRIO</u>: </strong>' + this.pruebasEquilibrioDiagnostic
                }

                try {
                    //GLICEMIA
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[13].valor == null) || this.listAnamnesis[0].signosVitales[13].valor == "")) {
                        htmlRed += '<br>-GLICEMIA'
                    } else {
                        htmlBlue += '<br><strong><u>-GLICEMIA</u>: </strong>' + this.listAnamnesis[0].signosVitales[13].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-GLICEMIA'
                }

                try {
                    //PRESION ARTERIA
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[1].valor == null) || this.listAnamnesis[0].signosVitales[1].valor == "")) {
                        htmlRed += '<br>-P.A.'
                    } else {
                        htmlBlue += '<br><strong><u>-P.A.</u>: </strong>' + this.listAnamnesis[0].signosVitales[1].valor + "/" + this.listAnamnesis[0].signosVitales[2].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-P.A.'
                }

                try {
                    //AUDIOMETRIA
                    if (this.audios[0] == null || ((this.audios[0].value.diagnosticos[0].name == null) || this.audios[0].value.diagnosticos[0].name == "")) {
                        htmlRed += '<br>-AUDIOMETRIA'
                    } else {
                        htmlBlue += '<br><strong><u>-AUDIOMETRIA</u>: </strong>' + this.audios[0].value.diagnosticos[0].name
                    }
                } catch (e) {
                    htmlRed += '<br>-AUDIOMETRIA'
                }

                if (htmlRed == "") {
                    this.cumple2 = true
                }
                htmlRed = '<font color="RED">' + htmlRed + '</font>'
                htmlBlue = '<font color="BLUE">' + htmlBlue + '</font>'
                this.html6 = htmlRed + htmlBlue


            },
            valueColum7() {
                //ENE/EEG
                //this.$store.state.fileData=[]
                let htmlRed = ""
                let htmlBlue = ""
                let today = new Date();
                let yyyy = today.getFullYear();
                for (let i = 0; i < this.$store.state.patientFileList.length; i++) {
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ELECTROENCEFALOGRAMA") || this.$store.state.patientFileList[i].group.includes("ELECTROENCEFALOGRAMA"))) {
                        this.eeg = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.eegDiagnostic = diagnosticsAnexos
                        //+" "+this.$store.state.patientFileList[i].diagnosticos==='undefined'?"":this.$store.state.patientFileList[i].diagnosticos
                    }
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ELECTROCARDIOGRAMA") || this.$store.state.patientFileList[i].group.includes("ECO-CARDIOGRAMA"))) {
                        this.ekg = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.ekgDiagnostic = diagnosticsAnexos
                    }
                }

                //EKG
                if (!this.ekg) {
                    htmlRed += '<br>-EKG'
                } else {
                    htmlBlue += '<br><strong><u>-EKG</u>: </strong>' + this.ekgDiagnostic
                }


                if (!this.eeg) {
                    htmlRed += '<br>-ENE/EEG'
                } else {
                    htmlBlue += '<br><strong><u>-ENE/EEG</u>: </strong>' + this.eegDiagnostic
                }

                try {
                    //PRESION ARTERIA
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[1].valor == null) || this.listAnamnesis[0].signosVitales[1].valor == "")) {
                        htmlRed += '<br>-P.A.'
                    } else {
                        htmlBlue += '<br><strong><u>-P.A.</u>: </strong>' + this.listAnamnesis[0].signosVitales[1].valor + "/" + this.listAnamnesis[0].signosVitales[2].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-P.A.'
                }

                try {
                    //AUDIOMETRIA
                    if (this.audios[0] == null || ((this.audios[0].value.diagnosticos[0].name == null) || this.audios[0].value.diagnosticos[0].name == "")) {
                        htmlRed += '<br>-AUDIOMETRIA'
                    } else {
                        htmlBlue += '<br><strong><u>-AUDIOMETRIA</u>: </strong>' + this.audios[0].value.diagnosticos[0].name
                    }
                } catch (e) {
                    htmlRed += '<br>-AUDIOMETRIA'
                }

                if (htmlRed == "") {
                    this.cumple2 = true
                }

                try {
                    //OFTALMOLOGIA
                    if (this.$store.state.oftalmoList == null || this.$store.state.oftalmoList.length == 0 || this.$store.state.oftalmoList[0].diagnosticoRefractivo1 == "") {
                        htmlRed += '<br>-OFTALMOLOGIA'
                    } else {
                        htmlBlue += '<br><strong><u>-OFTALMOLOGIA</u>: </strong>' + this.$store.state.oftalmoList[0].diagnosticoRefractivo1
                    }
                } catch (e) {
                    htmlRed += '<br>-OFTALMOLOGIA'
                }

                try {
                    //OFTALMOLOGIA
                    if (this.$store.state.oftalmoList == null || this.$store.state.oftalmoList.length == 0 || this.$store.state.oftalmoList[0].diagnosticoRefractivo2 == "") {
                        htmlRed += '<br>-OFTALMOLOGIA'
                    } else {
                        htmlBlue += '<br><strong><u>-OFTALMOLOGIA</u>: </strong>' + this.$store.state.oftalmoList[0].diagnosticoRefractivo2
                    }
                } catch (e) {
                    htmlRed += '<br>-OFTALMOLOGIA'
                }


                try {
                    //DALTONISMO
                    if (this.$store.state.oftalmoList == null || this.$store.state.oftalmoList.length == 0 || this.$store.state.oftalmoList[0].diagnosticoPatologico == "") {
                        htmlRed += '<br>-DALTONISMO'
                    } else if (this.$store.state.oftalmoList[0].diagnosticoPatologico != "DALTONISMO") {
                        htmlBlue += '<br><strong><u>-DALTONISMO</u>: </strong>' + "SI"
                    }
                } catch (e) {
                    htmlRed += '<br>-DALTONISMO'
                }

                if (htmlRed == "") {
                    this.cumple7 = true
                }

                htmlRed = '<font color="RED">' + htmlRed + '</font>'
                htmlBlue = '<font color="BLUE">' + htmlBlue + '</font>'
                this.html7 = htmlRed + htmlBlue


            },

            valueColum8() {
                //ENE/EEG
                //this.$store.state.fileData=[]
                let htmlRed = ""
                let htmlBlue = ""
                let today = new Date();
                let yyyy = today.getFullYear();
                for (let i = 0; i < this.$store.state.patientFileList.length; i++) {
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ELECTROENCEFALOGRAMA") || this.$store.state.patientFileList[i].group.includes("ELECTROENCEFALOGRAMA"))) {
                        this.eeg = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.eegDiagnostic = diagnosticsAnexos
                    }
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ELECTROCARDIOGRAMA") || this.$store.state.patientFileList[i].group.includes("ECO-CARDIOGRAMA"))) {
                        this.ekg = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.ekgDiagnostic = diagnosticsAnexos
                    }
                }
                if (!this.eeg) {
                    htmlRed += '<br>-ENE/EEG'
                } else {
                    htmlBlue += '<br><strong><u>-ENE/EEG</u>: </strong>' + this.eegDiagnostic
                }
                //EKG
                if (!this.ekg) {
                    htmlRed += '<br>-EKG'
                } else {
                    htmlBlue += '<br><strong><u>-EKG</u>: </strong>' + this.ekgDiagnostic
                }

                try {
                    //GLICEMIA
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[13].valor == null) || this.listAnamnesis[0].signosVitales[13].valor == "")) {
                        htmlRed += '<br>-GLICEMIA'
                    } else {
                        htmlBlue += '<br><strong><u>-GLICEMIA</u>: </strong>' + this.listAnamnesis[0].signosVitales[13].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-GLICEMIA'
                }

                try {
                    //PRESION ARTERIA
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[1].valor == null) || this.listAnamnesis[0].signosVitales[1].valor == "")) {
                        htmlRed += '<br>-P.A.'
                    } else {
                        htmlBlue += '<br><strong><u>-P.A.</u>: </strong>' + this.listAnamnesis[0].signosVitales[1].valor + "/" + this.listAnamnesis[0].signosVitales[2].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-P.A.'
                }

                //DOPPING
                if (this.fpeObject.dopping == "") {
                    htmlRed += '<br>-DOPING'
                } else if (this.fpeObject.dopping == 'POSITIVO') {
                    htmlBlue += '<br><strong><u>-DOPING</u>: </strong>POSITIVO'
                } else if (this.fpeObject.dopping == 'NEGATIVO') {
                    htmlBlue += '<br><strong><u>-DOPING</u>: </strong>NEGATIVO'
                }
                //ALCOHOL CHECK
                if (this.fpeObject.alcoholCheck == "") {
                    htmlRed += '<br>-ALCOHOL CHECK'
                } else if (this.fpeObject.alcoholCheck == 'POSITIVO') {
                    htmlBlue += '<br><strong><u>-ALCOHOL CHECK</u>: </strong>POSITIVO'
                } else if (this.fpeObject.alcoholCheck == 'NEGATIVO') {
                    htmlBlue += '<br><strong><u>-ALCOHOL CHECK</u>: </strong>NEGATIVO'
                }
                if (htmlRed == "") {
                    this.cumple8 = true
                }
                htmlRed = '<font color="RED">' + htmlRed + '</font>'
                htmlBlue = '<font color="BLUE">' + htmlBlue + '</font>'
                this.html8 = htmlRed + htmlBlue


            },
            valueColum9() {
                //ENE/EEG
                //this.$store.state.fileData=[]
                let htmlRed = ""
                let htmlBlue = ""
                let today = new Date();
                let yyyy = today.getFullYear();

                try {
                    //GLICEMIA
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[13].valor == null) || this.listAnamnesis[0].signosVitales[13].valor == "")) {
                        htmlRed += '<br>-GLICEMIA'
                    } else {
                        htmlBlue += '<br><strong><u>-GLICEMIA</u>: </strong>' + this.listAnamnesis[0].signosVitales[13].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-GLICEMIA'
                }

                try {
                    //OFTALMOLOGIA
                    if (this.$store.state.oftalmoList == null || this.$store.state.oftalmoList.length == 0 || this.$store.state.oftalmoList[0].diagnosticoRefractivo1 == "") {
                        htmlRed += '<br>-OFTALMOLOGIA'
                    } else {
                        htmlBlue += '<br><strong><u>-OFTALMOLOGIA</u>: </strong>' + this.$store.state.oftalmoList[0].diagnosticoRefractivo1
                    }
                } catch (e) {
                    htmlRed += '<br>-OFTALMOLOGIA'
                }

                try {
                    //OFTALMOLOGIA
                    if (this.$store.state.oftalmoList == null || this.$store.state.oftalmoList.length == 0 || this.$store.state.oftalmoList[0].diagnosticoRefractivo2 == "") {
                        htmlRed += '<br>-OFTALMOLOGIA'
                    } else {
                        htmlBlue += '<br><strong><u>-OFTALMOLOGIA</u>: </strong>' + this.$store.state.oftalmoList[0].diagnosticoRefractivo2
                    }
                } catch (e) {
                    htmlRed += '<br>-OFTALMOLOGIA'
                }

                try {
                    //DALTONISMO
                    if (this.$store.state.oftalmoList == null || this.$store.state.oftalmoList.length == 0 || this.$store.state.oftalmoList[0].diagnosticoPatologico == "") {
                        htmlRed += '<br>-DALTONISMO'
                    } else if (this.$store.state.oftalmoList[0].diagnosticoPatologico != "DALTONISMO") {
                        htmlBlue += '<br><strong><u>-DALTONISMO</u>: </strong>' + "SI"
                    }
                } catch (e) {
                    htmlRed += '<br>-DALTONISMO'
                }

                //DOPPING
                if (this.fpeObject.dopping == "") {
                    htmlRed += '<br>-DOPING'
                } else if (this.fpeObject.dopping == 'POSITIVO') {
                    htmlBlue += '<br><strong><u>-DOPING</u>: </strong>POSITIVO'
                } else if (this.fpeObject.dopping == 'NEGATIVO') {
                    htmlBlue += '<br><strong><u>-DOPING</u>: </strong>NEGATIVO'
                }
                //ALCOHOL CHECK
                if (this.fpeObject.alcoholCheck == "") {
                    htmlRed += '<br>-ALCOHOL CHECK'
                } else if (this.fpeObject.alcoholCheck == 'POSITIVO') {
                    htmlBlue += '<br><strong><u>-ALCOHOL CHECK</u>: </strong>POSITIVO'
                } else if (this.fpeObject.alcoholCheck == 'NEGATIVO') {
                    htmlBlue += '<br><strong><u>-ALCOHOL CHECK</u>: </strong>NEGATIVO'
                }
                if (htmlRed == "") {
                    this.cumple9 = true
                }
                htmlRed = '<font color="RED">' + htmlRed + '</font>'
                htmlBlue = '<font color="BLUE">' + htmlBlue + '</font>'
                this.html9 = htmlRed + htmlBlue


            },
            valueColum10() {
                //ENE/EEG
                //this.$store.state.fileData=[]
                let htmlRed = ""
                let htmlBlue = ""
                let today = new Date();
                let yyyy = today.getFullYear();
                for (let i = 0; i < this.$store.state.patientFileList.length; i++) {
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ELECTROENCEFALOGRAMA") || this.$store.state.patientFileList[i].group.includes("ELECTROENCEFALOGRAMA"))) {
                        this.eeg = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.eegDiagnostic = diagnosticsAnexos
                        //+" "+this.$store.state.patientFileList[i].diagnosticos==='undefined'?"":this.$store.state.patientFileList[i].diagnosticos
                    }
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ELECTROCARDIOGRAMA") || this.$store.state.patientFileList[i].group.includes("ECO-CARDIOGRAMA"))) {
                        this.ekg = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.ekgDiagnostic = diagnosticsAnexos
                    }

                }
                if (!this.eeg) {
                    htmlRed += '<br>-ENE/EEG'
                } else {
                    htmlBlue += '<br><strong><u>-ENE/EEG</u>: </strong>' + this.eegDiagnostic
                }
                //EKG
                if (!this.ekg) {
                    htmlRed += '<br>-EKG'
                } else {
                    htmlBlue += '<br><strong><u>-EKG</u>: </strong>' + this.ekgDiagnostic
                }

                try {
                    //GLICEMIA
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[13].valor == null) || this.listAnamnesis[0].signosVitales[13].valor == "")) {
                        htmlRed += '<br>-GLICEMIA'
                    } else {
                        htmlBlue += '<br><strong><u>-GLICEMIA</u>: </strong>' + this.listAnamnesis[0].signosVitales[13].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-GLICEMIA'
                }

                try {
                    //PRESION ARTERIA
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[1].valor == null) || this.listAnamnesis[0].signosVitales[1].valor == "")) {
                        htmlRed += '<br>-P.A.'
                    } else {
                        htmlBlue += '<br><strong><u>-P.A.</u>: </strong>' + this.listAnamnesis[0].signosVitales[1].valor + "/" + this.listAnamnesis[0].signosVitales[2].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-P.A.'
                }


                if (htmlRed == "") {
                    this.cumple10 = true
                }

                htmlRed = '<font color="RED">' + htmlRed + '</font>'
                htmlBlue = '<font color="BLUE">' + htmlBlue + '</font>'
                this.html10 = htmlRed + htmlBlue


            },

            valueColum11() {
                //ENE/EEG
                //this.$store.state.fileData=[]
                let htmlRed = ""
                let htmlBlue = ""
                let today = new Date();
                let yyyy = today.getFullYear();
                for (let i = 0; i < this.$store.state.patientFileList.length; i++) {

                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ELECTROCARDIOGRAMA") || this.$store.state.patientFileList[i].group.includes("ECO-CARDIOGRAMA"))) {
                        this.ekg = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.ekgDiagnostic = diagnosticsAnexos
                    }
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ANAMNESIS Y EXAMEN FÍSICO"))) {
                        this.historialClinico = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.historialClinicoDiagnostic = diagnosticsAnexos
                    }
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ESPIROMETRIA"))) {
                        this.espirometria = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.espirometriaDiagnostic = diagnosticsAnexos
                    }
                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("TORAX"))) {
                        this.rxTorax = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.rxToraxDiagnostic = diagnosticsAnexos
                    }

                    if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("MEDICIÓN DE PLIEGUES CUTANEOS"))) {
                        this.pliegues = true
                        let diagnosticsAnexos= "<br>"
                        if(this.$store.state.patientFileList[i].diagnostics!=null){
                            for(let j=0; j<this.$store.state.patientFileList[i].diagnostics.length; j++){
                                diagnosticsAnexos = diagnosticsAnexos + this.$store.state.patientFileList[i].diagnostics[j].name + " "
                            }
                        }
                        this.plieguesDiagnostic = diagnosticsAnexos
                    }


                }

                if (!this.espirometria) {
                    htmlRed += '<br>-ESPIROMETRIA'
                } else {
                    htmlBlue += '<br><strong><u>-ESPIROMETRIA</u>: </strong>' + this.espirometriaDiagnostic
                }
                if (!this.rxTorax) {
                    htmlRed += '<br>-RX TORAX'
                } else {
                    htmlBlue += '<br><strong><u>-RX TORAX</u>: </strong>' + this.rxToraxDiagnostic
                }
                //EKG
                if (!this.ekg) {
                    htmlRed += '<br>-EKG'
                } else {
                    htmlBlue += '<br><strong><u>-EKG</u>: </strong>' + this.ekgDiagnostic
                }

                //HISTORIA CLINICA
                if (!this.historialClinico) {
                    htmlRed += '<br>-HISTORIA CLINICA/EXAMEN FÍSICO'
                } else {
                    htmlBlue += '<br><strong><u>-HISTORIA CLINICA/EXAMEN FÍSICO</u>: </strong>' + this.historialClinicoDiagnostic
                }

                try {
                    //GLICEMIA
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[13].valor == null) || this.listAnamnesis[0].signosVitales[13].valor == "")) {
                        htmlRed += '<br>-GLICEMIA'
                    } else {
                        htmlBlue += '<br><strong><u>-GLICEMIA</u>: </strong>' + this.listAnamnesis[0].signosVitales[13].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-GLICEMIA'
                }

                try {
                    //PRESION ARTERIA
                    if (this.listAnamnesis[0] == null || ((this.listAnamnesis[0].signosVitales[1].valor == null) || this.listAnamnesis[0].signosVitales[1].valor == "")) {
                        htmlRed += '<br>-P.A.'
                    } else {
                        htmlBlue += '<br><strong><u>-P.A.</u>: </strong>' + this.listAnamnesis[0].signosVitales[1].valor + "/" + this.listAnamnesis[0].signosVitales[2].valor
                    }
                } catch (e) {
                    htmlRed += '<br>-P.A.'
                }

                //t3t4tsh
                if (this.fpeObject.t3t4tsh == "") {
                    htmlRed += '<br>-T3-T4-TSH'
                } else if (this.fpeObject.t3t4tsh == 'NORMAL') {
                    htmlBlue += '<br><strong><u>-T3-T4-TSH</u>: </strong>NORMAL'
                } else if (this.fpeObject.t3t4tsh == 'ANORMAL') {
                    htmlBlue += '<br><strong><u>-T3-T4-TSH</u>: </strong>ANORMAL'
                }

                //PLIEGUES
                if (!this.pliegues) {
                    htmlRed += '<br>-PLIEGUES'
                } else {
                    htmlBlue += '<br><strong><u>-PLIEGUES</u>: </strong>' + this.plieguesDiagnostic
                }
                if (htmlRed == "") {
                    this.cumple11 = true
                }
                htmlRed = '<font color="RED">' + htmlRed + '</font>'
                htmlBlue = '<font color="BLUE">' + htmlBlue + '</font>'
                this.html11 = htmlRed + htmlBlue


            },
            save() {
                if (this.$refs.form.validate()) {
                    this.fpeObject.date = new Date()
                    if (this.fpeObject.id != null) {
                        this.$store.dispatch('updatePatientFpe', this.fpeObject).then(response => {
                            this.dialog = false
                            this.dialogSuccess = true
                            this.cleanData()
                            this.reload()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    } else {
                        this.$store.dispatch('addPatientFpe', this.fpeObject).then(response => {
                            this.dialog = false
                            this.dialogSuccess = true
                            this.reload()
                            this.cleanData()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    }

                }
            },
            reload() {
                this.$store.dispatch('getPatientFpeByRouteSheets', this.$store.state.routeSheet.id).then(response => {
                    this.fpeObject = response.data
                    if (this.fpeObject == "") {
                        this.fpeObject = {}
                        this.fpeObject.date = new Date()
                        this.fpeObject.patientRouteSheet = this.$store.state.routeSheet
                        this.fpeObject.dopping = null
                        this.fpeObject.alcoholCheck = null
                        this.fpeObject.t3t4tsh = null
                        this.fpeObject.fpe1 = false
                        this.fpeObject.fpe3 = false
                        this.fpeObject.fpe4 = false
                        this.fpeObject.fpe6 = false
                        this.fpeObject.fpe7 = false
                        this.fpeObject.fpe8 = false
                        this.fpeObject.fpe9 = false
                        this.fpeObject.fpe10 = false
                        this.fpeObject.fpe11 = false
                        this.fpeObject.fpe12 = false
                        this.fpeObject.fpe13 = false
                    }
                    this.$store.dispatch('getPatientAnamnesisByRouteSheets', this.$store.state.routeSheet.id).then(response => {
                        this.listAnamnesis = []
                        for (let i = 0; i < this.$store.state.anamnesisList.length; i++) {
                            this.doctor = this.$store.state.anamnesisList[i].usuarioCreaActualiza?this.$store.state.anamnesisList[i].usuarioCreaActualiza:''
                            let anam = JSON.parse(this.$store.state.anamnesisList[i].value)
                            anam.id = this.$store.state.anamnesisList[i].id
                            this.listAnamnesis.push(anam)
                        }
                        //this.$store.state.fileData=[]
                        this.$store.dispatch('getPatientFileByRouteSheets', this.$store.state.routeSheet.id).then(response => {
                            this.$store.dispatch('getPatientAudioByRouteSheets', this.$store.state.routeSheet.id).then(response => {
                                this.audios = response.data
                                for (let i = 0; i < this.audios.length; i++) {
                                    this.audios[i].value = JSON.parse(this.audios[i].value);
                                }
                                this.valueColum1()
                                this.valueColum2()
                                this.valueColum3()
                                this.valueColum4()
                                this.valueColum5()
                                this.valueColum6()
                                this.valueColum7()
                                this.valueColum8()
                                this.valueColum9()
                                this.valueColum10()
                                this.valueColum11()
                            }, error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                            })

                        }, error => {
                            this.$store.state.progress = false;
                            this.$store.state.dialogError = true;
                        })

                    }, error => {
                        this.$store.state.progress = false;
                        this.$store.state.dialogError = true;
                    })
                })
            },
            getDateLong(){
                var meses = new Array ("Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre");
                var f=new Date();
                return 'Quito, '+f.getDate() + " de " + meses[f.getMonth()] + " de " + f.getFullYear()
            },
            print() {
                if (this.fpeObject.fpe1) {
                    this.getDocDefinition(1)
                }
                if (this.fpeObject.fpe3) {
                    this.getDocDefinition(3)
                }
                if (this.fpeObject.fpe4) {
                    this.getDocDefinition(4)
                }
                if (this.fpeObject.fpe6) {
                    this.getDocDefinition(6)
                }
                if (this.fpeObject.fpe7) {
                    this.getDocDefinition(7)
                }
                if (this.fpeObject.fpe8) {
                    this.getDocDefinition(8)
                }
                if (this.fpeObject.fpe9) {
                    this.getDocDefinition(9)
                }
                if (this.fpeObject.fpe10) {
                    this.getDocDefinition(10)
                }
                if (this.fpeObject.fpe11) {
                    this.getDocDefinition(11)
                }
                if (this.fpeObject.fpe12) {
                    this.getDocDefinition(12)
                }
                if (this.fpeObject.fpe13) {
                    this.getDocDefinition(13)
                }
            },
            getDocDefinition(fpe){
                let docDefinition = {
                    pageMargins: [40, 60, 40, 60],
                    content: [
                        {
                            image: 'data:image/png;base64,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\n',
                            width: 80,
                            margin: [210, 0, 0, 0],
                        },
                        {
                            style: 'response0',
                            italics: false,
                            text: [
                                this.getDateLong()+
                                '\n\n' +
                                '\n\n' +
                                '\n\n'
                            ]
                        },
                        {
                            text: 'CERTIFICACIÓN PARA PREVENCIÓN EVENTO FATAL , TRABAJOS\n' +
                                'ESPECIALES (FPE/ESTANDAR )\n\n\n',
                            style: 'header',
                            alignment: 'center'
                        },

                        {
                            style: 'bigger',
                            italics: false,
                            text: [
                                {
                                    text: 'Por medio del presente certifico que el Sr(a) ',
                                    style: 'response0'
                                }, {
                                    text: this.$store.state.routeSheet.patient.firstLastName + " " + this.$store.state.routeSheet.patient.secondLastName + " ",
                                    style: 'response'
                                }, {
                                    text: this.$store.state.routeSheet.patient.firstName + " " + this.$store.state.routeSheet.patient.secondName + " ",
                                    style: 'response'
                                },
                                {
                                    text: 'con CI:',
                                    style: 'response0'
                                }, {text: this.$store.state.routeSheet.patient.identification + " ", style: 'response'},
                                {
                                    text: 'ha efectuado sus exámenes médicos contemplados en ',
                                    style: 'response0'
                                }, {text: " FPE/ESTANDAR #"+fpe, style: 'response'},
                                {text: ' y se encuentra APTO. ', style: 'response0'}

                            ]
                        },
                        {
                            style: 'response0',
                            italics: false,
                            text: [
                                '\n\n' +
                                '\n\n' +
                                'Atentamente.\n\n' +
                                '\n\n' +
                                '\n\n' +
                                '\n\n'
                            ]
                        },

                        {
                            style: 'response0',
                            italics: false,
                            text: [
                                '\n\n' +
                                '\n\n' +
                                this.doctor +
                                'Médico Ocupacional\n' +
                                '\n\n' +
                                '\n\n' +
                                '\n\n'
                            ]
                        },

                    ],
                    pageBreakBefore: function (currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
                        return currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0;
                    },
                    styles: {
                        header: {
                            fontSize: 14,
                            bold: true
                        },
                        response: {
                            fontSize: 10,
                            bold: true
                        },
                        response0: {
                            fontSize: 10,
                            bold: false
                        },
                        subheader: {
                            fontSize: 15,
                            bold: true
                        },
                        quote: {
                            italics: true
                        },
                        tableExample: {
                            margin: [0, 5, 0, 15],
                            fontSize: 8

                        },
                        tableHeader: {
                            margin: [35, 20, 0, 15],
                            fontSize: 8

                        },
                        tableLittle: {
                            margin: [0, 0, 0, 15],
                            fontSize: 6

                        },
                        bigger: {
                            fontSize: 15,
                            italics: true
                        }
                    }
                }
                const pdfDocGenerator = pdfMake.createPdf(docDefinition);
                pdfDocGenerator.getBase64((data) => {
                    let anexo = new Anexo();
                    anexo.date = new Date();
                    anexo.patientRouteSheet = this.$store.state.routeSheet;
                    anexo.file = data;
                    anexo.year = anexo.date.getFullYear();
                    anexo.fileName = 'CERTIFICADO-FPE'+fpe+'.pdf';
                    anexo.description = 'CERTIFICADO FPE'+fpe+' GENERADO POR EL SISTEMA';
                    anexo.group = 'Certificados';
                    anexo.diagnostics = JSON.stringify([]);
                    this.$store.dispatch('addPatientFile', anexo).then(response => {
                        alert('El certificado para FPE'+fpe+' ha sido generado. Por favor revise en la sección anexos.');
                    }, error => {
                        this.$store.state.progress = false
                        this.$store.state.dialogError = true
                    })
                });
            }



        },
        computed: {},
        created() {
            this.reload()

        },
        components: {}
    };
</script>

<style scoped>
    .containerScroll {
        width: 100%;
        overflow-x: auto;
        white-space: nowrap;
    }
</style>



// WEBPACK FOOTER //
// src/components/patient/fpe/Fpe.vue